import { connect } from 'react-redux';
import { isAdminAccess, isManagedResource, isCollaborator, isOperator } from 'js/lib/ACLUtils';
import { getConnectionOrVendorType } from 'js/lib/ResourceUtils';

import has from 'lodash/has';

export const mapStateToProps = (state, ownProps) => {
  const {
    paging,
    paging: { metaInfoById },
    entities: { users, vendors },
  } = state;
  const { cardData } = ownProps;

  const adminAccess = isAdminAccess(cardData);
  const isManaged = isManagedResource(cardData);
  const readOnly = isCollaborator(cardData) || isOperator(cardData);

  const owner = has(cardData, 'owner') && has(users, cardData.owner) ? users[cardData.owner] : null;
  let connectionInfo = null,
    connectionOrVendorType = null;

  if (cardData.id) {
    connectionOrVendorType = getConnectionOrVendorType(
      cardData,
      vendors,
      'credentials_type',
      'vendor_id',
    );

    if (connectionOrVendorType && has(metaInfoById, connectionOrVendorType)) {
      connectionInfo = metaInfoById[connectionOrVendorType];
    }
  }

  return {
    connectionAuthFields: paging.connAuthById,
    connectionInfo,
    connectionOrVendorType,
    readOnly,
    adminAccess,
    isManaged,
    owner,
  };
};
